// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R2qjCByZiUGyy21Qzp9u{flex-direction:column;width:280px;display:flex}.R2qjCByZiUGyy21Qzp9u>div{width:100%}.JhG4czTGYILbkt8eaywI{flex-direction:column;padding:4px;display:flex}.YnxzgZd1vBIR4djuNUJ0{cursor:pointer;border-radius:6px;align-items:center;gap:8px;padding:8px 8px 8px 11px;display:flex}.YnxzgZd1vBIR4djuNUJ0:hover{background:var(--background-neutral-subtle)}.iyg8Qjgux08v9ImX9eje{color:var(--content-brand-primary)}.jcygRWLNjgwbsMk7oyF0{margin-bottom:2px;padding:7px 6px 6px 7px}.jcygRWLNjgwbsMk7oyF0:before{left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `R2qjCByZiUGyy21Qzp9u`,
	"actionList": `JhG4czTGYILbkt8eaywI`,
	"actionItem": `YnxzgZd1vBIR4djuNUJ0`,
	"actionIcon": `iyg8Qjgux08v9ImX9eje`,
	"tabs": `jcygRWLNjgwbsMk7oyF0`
};
export default ___CSS_LOADER_EXPORT___;
